export default __webpack_public_path__ + "static/media/es-ar.e4c3d11c.svg";